import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../environment';
import {
  IDeliveryMethodsAvailabilityRequestEntity,
  IDeliveryMethodsAvailabilityResponseEntity
} from '../../model/api/delivery-methods';
import { HttpProvider } from '../http/http';
import { LoggerEvent, LoggerProvider } from '../logger/logger';

@Injectable()
export class DeliveryMethodAvailabilityProvider {
  private cache: { [key: string]: IDeliveryMethodsAvailabilityResponseEntity } = {};

  constructor(private httpProvider: HttpProvider) {
  }

  async getAvailability(params: IDeliveryMethodsAvailabilityRequestEntity): Promise<IDeliveryMethodsAvailabilityResponseEntity> {
    const key = this.cacheKey(params);
    if (this.cache[key])
      return this.cache[key];

    try {
      const res: IDeliveryMethodsAvailabilityResponseEntity =
        await this.httpProvider.post(`${APP_CONFIG.API_URL}api/delivery-methods/availability`, params);
      if (!res || !res.Results || res.Results.length === 0) {
        LoggerProvider.info(this, 'Delivery method availability returned no verdicts, keeping the calculate list', res);
        return null;
      }
      this.cache[key] = res;
      return res;
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Delivery method availability failed, keeping the calculate list');
      return null;
    }
  }

  logout(): void {
    this.cache = {};
  }

  private cacheKey(params: IDeliveryMethodsAvailabilityRequestEntity): string {
    return [
      params.countryFrom,
      params.countryTo,
      params.currencyFrom,
      params.currencyTo,
      params.amountFrom,
      params.amountTo,
      params.stateFrom,
      params.stateTo,
      params.paymentMethod,
      params.includeRates,
      (params.deliveryMethods || []).join(',')
    ].join('|');
  }
}



// WEBPACK FOOTER //
// ./src/providers/delivery-method-availability/delivery-method-availability.ts